export default "/_next/static/images/8db7f67afdc667b48f4baa9160eac0f3.jpg";